import { useI18n } from '../i18n';
import { GetItButton } from '../components/GetItButton';
import { Arrow } from './Hero';
import styles from './Pricing.module.css';

/**
 * What it costs, which is nothing.
 *
 * ## Why this is not a card
 *
 * It was two — Free and Pro, side by side — and when Pro went the survivor kept
 * its border. That was wrong, and not only cosmetically: a card is a
 * comparison device. The box, the rule around it and the equal-height stretch
 * all exist to say "this one, or that one". With one tier there is no *that
 * one*, so the border was drawing a boundary around the only thing on offer
 * and inviting a reader to look for what it was being weighed against.
 *
 * So it reads as a section now, like the FAQ and the stats band: a kicker, a
 * statement, and hairline rules doing the separating. Nothing on this page is
 * boxed except things there are several of.
 *
 * The price keeps its treatment. "all of it" is still a value, values are the
 * handwritten voice, and it still sits on the name's own line rather than
 * under it.
 */
export function Pricing() {
  const { t } = useI18n();
  const p = t.pricing;

  return (
    <section className={styles.section} id="free">
      <p className={`caps ${styles.kicker}`}>{p.kicker}</p>

      <div className={styles.lede}>
        <h2 className={styles.name}>{p.name}</h2>
        <span className={`hand ${styles.price}`}>{p.price}</span>
      </div>
      <p className={`hand ${styles.tagline}`}>{p.tagline}</p>
      <p className={styles.blurb}>{p.blurb}</p>

      <ul className={styles.items}>
        {p.items.map((item) => (
          <li key={item} className={styles.item}>
            <span className={`hand ${styles.tick}`} aria-hidden="true">
              ✓
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <p className={styles.note}>{p.note}</p>

      <div className={styles.action}>
        <GetItButton source="pricing-free" variant="primary" size="lg">
          {t.hero.cta}
          <Arrow />
        </GetItButton>
      </div>
    </section>
  );
}
